import GuestControlService from "@/service/guest-control-service";

export default class GuestControlStrategy {
  constructor() {
    this.guestControlService = new GuestControlService();
    this.lang = this.handleLang();
  }

  async redirect(reservation, guest) {
    const personId = guest.personId;
    let externalAccess = await this.guestControlService.getExternalAccess(
      reservation.companyId,
      personId,
      reservation.reservationNumber
    );

    if (!externalAccess) {
      externalAccess = await this.guestControlService.createExternalAccess(
        reservation.companyId,
        personId,
        reservation.reservationNumber,
        guest.name,
        guest.lastName,
        reservation.roomCode,
        reservation.checkoutDate
      );
    }

    if (externalAccess.token) {
      const { portalUrl } = await this.guestControlService.getUrl();
      window.location.href = `${portalUrl}/guest-control/start/${externalAccess.token}?lang=${this.lang}`;
    }
  }

  async redirectWalkIn(companyId) {
    const externalAccess = await this.guestControlService.createExternalAccess(
      companyId,
      null,
      null,
      null,
      null,
      null,
      null,
      true
    );

    if (externalAccess.token) {
      const { portalUrl } = await this.guestControlService.getUrl();
      window.location.href = `${portalUrl}/guest-control/start/${externalAccess.token}?lang=${this.lang}`;
    }
  }

  handleLang() {
    const lang = localStorage.getItem("currentLang");
    switch (lang) {
      case "pt":
        return "pt_BR";
      case "en":
      case "uk":
        return "en_US";
      case "es":
        return "es_ES";
      default:
        return "pt_BR";
    }
  }
}
